import React, { Component } from "react";
import { Routes, Route } from "react-router-dom";
import { withRouterLegacy } from "core/routerUtils";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as eventChecklistActions from "features/event-checklist/duck";
import * as tcEventActions from "features/tc-event-dashboard/duck";
import {
  getEventTasksCompleted,
  getToDoEventTasks,
} from "features/event-checklist/selectors";
import {
  EventChecklistDashboard,
  TaskContainer,
} from "features/event-checklist/index";
import { PageNotFound, Spinner } from "shared/components/index";
import { CATEGORY_PRE_TEST, CATEGORY_POST_TEST } from "shared/constants";
import { isEmpty } from "lodash";

import "./EventChecklistContainer.scss";

class EventChecklistContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      taskCategory: CATEGORY_PRE_TEST,
      showSuccessMessage: false,
    };

    this.renderDashboard = this.renderDashboard.bind(this);
    this.updateTask = this.updateTask.bind(this);
    this.goBack = this.goBack.bind(this);

    const { params } = props.match;

    if (isEmpty(props.tcEvent)) {
      this.props.actions.getTcEvent(params.eventId).then(() => {
        this.props.actions.getTestCenterCycle(params.eventId);
      });
    }

    if (!props.eventTasks.pre.length && !props.eventTasks.post.length) {
      this.props.actions.getEventTasks(params.eventId, {
        category: CATEGORY_PRE_TEST,
      });
      this.props.actions.getEventTasks(params.eventId, {
        category: CATEGORY_POST_TEST,
      });
    }
  }

  updateTask(taskList, category, changed) {
    if (changed) {
      this.props.actions
        .updateTask(this.props.match.params.eventId, taskList)
        .then(() => {
          if (isEmpty(this.props.errorUpdate)) {
            this.setState({
              taskCategory: category,
              showSuccessMessage: true,
            });
            this.props.history.goBack();
            this.props.actions.getEventTasks(this.props.match.params.eventId, {
              category,
            });
          }
        });
      return;
    }
    this.props.history.goBack();
  }

  goBack(task) {
    if (task) {
      this.setState({
        taskCategory: task.category,
        showSuccessMessage: false,
      });
      this.props.actions.clearErrorAction();
    }

    this.props.history.goBack();
  }

  renderDashboard() {
    const { taskCategory, showSuccessMessage } = this.state;

    return (
      <EventChecklistDashboard
        {...this.props}
        showPre={taskCategory === CATEGORY_PRE_TEST}
        showSuccessMessage={showSuccessMessage}
        goBack={this.goBack}
      />
    );
  }

  render() {
    const { tcEvent, tcCycle } = this.props;

    if (isEmpty(tcEvent) || isEmpty(tcCycle)) {
      return <Spinner />;
    }

    return (
      <div className="event-checklist-container">
        <Routes>
          <Route index element={this.renderDashboard()} />
          <Route path=":taskId" element={<TaskView parent={this} />} />
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </div>
    );
  }
}

// Helper component to access route params
const TaskView = withRouterLegacy(({ parent, match }) => {
  const { tcEvent, tcCycle, eventTasks, errorUpdate, loadingUpdateTask } =
    parent.props;
  const allTasks = [...eventTasks.pre, ...eventTasks.post];
  const findTask = allTasks.find(
    (task) => task.taskId === +match.params.taskId
  );

  return (
    !!findTask && (
      <TaskContainer
        task={findTask}
        tcEvent={tcEvent}
        tcCycle={tcCycle}
        updateTask={parent.updateTask}
        errorUpdate={errorUpdate}
        loadingUpdateTask={loadingUpdateTask}
        goBack={parent.goBack}
      />
    )
  );
});

function mapStateToProps(state) {
  return {
    eventTasks: state.eventChecklist.eventTasks,
    loadingEventTasks: state.eventChecklist.loadingEventTasks,
    tcEvent: state.tcEvent.currentEvent || {},
    tcCycle: state.tcEvent.testCenterCycle || {},
    errorUpdate: state.eventChecklist.errorUpdate,
    loadingUpdateTask: state.eventChecklist.loadingUpdateTask,
    completedEventTasks: getEventTasksCompleted(state),
    toDoEventTasks: getToDoEventTasks(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      { ...eventChecklistActions, ...tcEventActions },
      dispatch
    ),
  };
}

export default withRouterLegacy(
  connect(mapStateToProps, mapDispatchToProps)(EventChecklistContainer)
);

EventChecklistContainer.propTypes = {
  tcCycle: PropTypes.shape({}).isRequired,
  tcEvent: PropTypes.shape({}).isRequired,
  eventTasks: PropTypes.shape({}).isRequired,
  completedEventTasks: PropTypes.shape({}).isRequired,
  toDoEventTasks: PropTypes.shape({}).isRequired,
  errorUpdate: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string]),
  actions: PropTypes.shape({
    clearErrorAction: PropTypes.func,
    getEventTasks: PropTypes.func,
    updateTask: PropTypes.func,
    getTcEvent: PropTypes.func,
    getTestCenterCycle: PropTypes.func,
  }).isRequired,
  history: PropTypes.shape({
    goBack: PropTypes.func,
  }),
};

EventChecklistContainer.defaultProps = {};
